var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"base-logo",attrs:{"to":"/"}},[_vm._v("Hot Or Not")])}
var staticRenderFns = []

export { render, staticRenderFns }